import React from 'react';
import SVGIcon, { SVGIcons } from './svgIcon';
import Translate from './localization/localize';
import { MessageType } from '../../core/localization';

import './flaggedMsg.scss';

export enum FlagTypes {
  Info,
  Success,
  Error,
  Warning,
}

const FlagColors = {
  [FlagTypes.Error]: 'Red',
  [FlagTypes.Warning]: 'Yellow',
  [FlagTypes.Info]: 'cyan',
  [FlagTypes.Success]: 'green',
};

interface Props {
  label?: MessageType;
  type?: FlagTypes;
}

const FlaggedMsg: React.FC<Props> = (props) => {
  const label = props.label || '';
  const flagType = props.type || FlagTypes.Error;
  const iconClass = `icon`;
  const fill = FlagColors[flagType];

  return (
    <div className="flagged_msg">
      <span className={iconClass}>
        <SVGIcon name={SVGIcons.Flag} fill={fill} width="100%" height="100%" />
      </span>
      <span className="flag_message">
        <Translate message={label} />
      </span>
    </div>
  );
};

export default FlaggedMsg;
